import { render, staticRenderFns } from "./IconAndTextComponent.vue?vue&type=template&id=64b0d47f"
import script from "./IconAndTextComponent.vue?vue&type=script&lang=js"
export * from "./IconAndTextComponent.vue?vue&type=script&lang=js"
import style0 from "./IconAndTextComponent.vue?vue&type=style&index=0&id=64b0d47f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports